<div class="content">
    
    <div class="logo-content">
        <img class="brand" src="assets/images/confirm-circle.png">
    </div>

    <div class="success-message">
        <p><b>Senha gerada com sucesso!</b></p>
        <p>Aguarde ser chamado no painel.</p>
    </div>
    <div class="success-ticket">
        <div class="ticket">
            <span>{{ticket}}</span>
        </div>
        
        <div class="ticket-date">
            <label>Data: </label> 
            {{generateEpisodeResponse.ticketGenerationDate | date:'dd/MM/yyyy'}} 
            
            <label class="hour">Hora: </label> 
            {{ generateEpisodeResponse.ticketGenerationDate | date:'HH:mm':"+0000" }}
        </div>
    </div>
    
    <span class="info-message spinner-color spinner-totem">
        <mat-spinner [diameter]="40" class="mat-spinner-btn"></mat-spinner>
    </span>
    <span class="info-message">Imprimindo sua senha, aguarde!</span>
</div>
